import { SVGProps } from 'react';

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M6.79412 14.4C6.30882 14.4 5.89338 14.2238 5.54779 13.8713C5.20221 13.5188 5.02941 13.095 5.02941 12.6V1.8C5.02941 1.305 5.20221 0.88125 5.54779 0.52875C5.89338 0.17625 6.30882 0 6.79412 0H14.7353C15.2206 0 15.636 0.17625 15.9816 0.52875C16.3272 0.88125 16.5 1.305 16.5 1.8V12.6C16.5 13.095 16.3272 13.5188 15.9816 13.8713C15.636 14.2238 15.2206 14.4 14.7353 14.4H6.79412ZM6.79412 12.6H14.7353V1.8H6.79412V12.6ZM3.26471 18C2.77941 18 2.36397 17.8238 2.01838 17.4713C1.67279 17.1188 1.5 16.695 1.5 16.2V3.6H3.26471V16.2H12.9706V18H3.26471Z"
      fill="currentColor"
    />
  </svg>
);
